var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "modal-title-big" }, [
      _vm._v("\n        Пользователь\n    ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ap-modal-element profile-grid" }, [
      _c("div", [_vm._v("Имя:")]),
      _vm._v(" "),
      _c("div", [_vm._v(_vm._s(_vm.userName))]),
      _vm._v(" "),
      _c("div", [_vm._v("E-mail:")]),
      _vm._v(" "),
      _c("div", [_vm._v(_vm._s(_vm.userEmail))]),
      _vm._v(" "),
      _c("div", [_vm._v("Роль:")]),
      _vm._v(" "),
      _c("div", [_vm._v(_vm._s(_vm.userRole))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }